/* tslint:disable */
/**
 * google 地图
 * Created at 2021-10-11 16:13
 * @author teapot
 */
import "./index.css";

import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from "react-google-maps";
import { useTranslation } from "react-i18next";

const GoogleMaps = () => {
  return <MyMapComponent />;
};

const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyDAQdOsPXxk_VHqjoVXOj4M7ovQeKjezI4&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `50vh` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(() => {
  const { t } = useTranslation();

  return (
    <GoogleMap
      defaultZoom={18}
      defaultCenter={{ lat: 22.2778356, lng: 114.1728 }}
    >
      <Marker position={{ lat: 22.2778356, lng: 114.1728 }}>
        <InfoWindow>
          <div>
            {t('nav_title')}
          </div>
        </InfoWindow>
      </Marker>
    </GoogleMap>
  );
});

export default GoogleMaps;
